import { ApiSuccess, ApiTagTypes } from '../../types';
import { apiSlice } from '../api.services';

type CreateFolderPayload = {
  name: string;
  parentId?: string | null;
};

type EditFolderPayload = CreateFolderPayload & {
  id: string;
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createFolder: builder.mutation<ApiSuccess, CreateFolderPayload>({
      query: (body) => ({
        url: '/folders',
        method: 'POST',
        body,
      }),
      invalidatesTags: (__, ___, { parentId }) => [
        // Invalidate the folders list cache.
        // Crucial for refreshing the folder hierarchy tree in the folder location modals.
        ApiTagTypes.FOLDERS,
        // Invalidate the parent folder's cache.
        // Crucial for refreshing the subfolder list in the parent folder's view.
        ...(parentId ? [{ type: ApiTagTypes.FOLDERS, id: parentId }] : []),
      ],
    }),
    editFolder: builder.mutation<ApiSuccess, EditFolderPayload>({
      query: ({ id, ...body }) => ({
        url: `/folders/${id}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (__, ___, { id }) => [{ type: ApiTagTypes.FOLDERS, id }, ApiTagTypes.FOLDERS],
    }),
    deleteFolder: builder.mutation<ApiSuccess, string>({
      query: (id) => ({
        url: `/folders/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ApiTagTypes.FOLDERS],
    }),
  }),
});

export const { useCreateFolderMutation, useEditFolderMutation, useDeleteFolderMutation } = enhancedApiSlice;
